export default __webpack_public_path__ + "static/media/support.90b75c81.png";